import { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '../../../../components/molecules/Typography';

interface ISearchInput extends React.InputHTMLAttributes<HTMLInputElement> {
  onSearchSubmit?: () => void;
}

export default function SearchInput({
  onSearchSubmit,
  ...props
}: ISearchInput) {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState('');
  const [error, setError] = useState<boolean>(false);

  const onSearch = () => {
    const term = searchTerm.trim();

    if (term.length < 3) {
      setError(true);
      return;
    }

    // Sem o encode, "1/2", "50%" ou "#" quebram a rota antes de chegar na busca.
    const baseUrl = '/search/' + encodeURIComponent(term);
    navigate(baseUrl);
    onSearchSubmit?.();
  };

  return (
    <Fragment>
      <input
        className={`block rounded-md border-mono-color-dark bg-mono-color-white text-sm text-mono-color-black placeholder:text-mono-color-black xs:w-[235px] lg:w-[435px]`}
        placeholder='O que você está procurando?'
        onChange={(e) => {
          if (error) setError(false);

          setSearchTerm(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.keyCode === 13) {
            onSearch();
          }
        }}
        {...props}
      />
      {error && (
        <Typography size='mini' className='mt-2 text-feedback-color-error-pure'>
          {' '}
          Digite no minimo 3 caracteres{' '}
        </Typography>
      )}
    </Fragment>
  );
}
